var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3656 13.4725L16.5878 12.2225C16.7788 12.0272 17.1111 12.1639 17.1111 12.4452V18.1249C17.1111 19.16 16.2899 19.9999 15.2778 19.9999H1.83333C0.821181 19.9999 0 19.16 0 18.1249V4.37488C0 3.33972 0.821181 2.49988 1.83333 2.49988H12.2795C12.5507 2.49988 12.6882 2.83582 12.4972 3.03503L11.275 4.28503C11.2177 4.34363 11.1413 4.37488 11.0573 4.37488H1.83333V18.1249H15.2778V13.6913C15.2778 13.6093 15.3083 13.5311 15.3656 13.4725ZM21.3469 5.58972L11.317 15.8475L7.86424 16.2382C6.86354 16.3514 6.01181 15.4882 6.12257 14.4569L6.50451 10.9257L16.5344 0.667847C17.409 -0.226685 18.8222 -0.226685 19.6931 0.667847L21.3431 2.35535C22.2177 3.24988 22.2177 4.6991 21.3469 5.58972ZM17.5733 6.79675L15.3542 4.52722L8.25764 11.7889L7.97882 14.3397L10.4729 14.0546L17.5733 6.79675ZM20.0483 3.68347L18.3983 1.99597C18.2417 1.83582 17.9858 1.83582 17.833 1.99597L16.6528 3.203L18.8719 5.47253L20.0521 4.2655C20.2049 4.10144 20.2049 3.84363 20.0483 3.68347Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRegular);
export default __webpack_public_path__ + "static/media/edit-regular.a825903d.svg";
export { ForwardRef as ReactComponent };